import { useQuery } from '@tanstack/react-query';

import { dashboardV2Client } from '../api/client';
import { dashboardLiveQueryOptions } from '../api/liveQuery';
import { dashboardV2QueryKeys } from '../api/queryKeys';
import { ShiftDetailData } from '../api/types';

// Shift Detail side-panel data. Fetches only when a shift is selected
// (shiftId != null). Polls like the calendar (review D-01): the panel shows
// server-built countdowns ("next round in 5 mins") and fill reasons, which
// otherwise stay frozen at open while the card behind the panel moves on.
const useShiftDetail = (agencyId: number, shiftId: number | null) =>
  useQuery<ShiftDetailData>({
    ...dashboardLiveQueryOptions,
    queryKey: dashboardV2QueryKeys.shiftDetail(agencyId, shiftId ?? 0),
    queryFn: () =>
      dashboardV2Client.getShiftDetail(agencyId, shiftId as number),
    enabled: agencyId != null && shiftId != null,
  });

export default useShiftDetail;
